var _line, _polyline, _polyline2, _polyline3, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharacterCardBorderBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-d8849b44-acb5-461b-a1ea-31fef3e17818",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 524.20931 17.95141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 524.20931,
    y1: 2,
    y2: 2,
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "248.98626 2.2645 263.25896 16.5372 277.53166 2.2645",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "269.10186 10.7286 380.91896 10.7286 389.23616 2.4115",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "258.03806 10.7286 145.59896 10.7286 137.28186 2.4115",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 153.91616,
    y1: 10.7286,
    x2: 145.59896,
    y2: 2.4115,
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 372.60186,
    y1: 10.7286,
    x2: 380.91896,
    y2: 2.4115,
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterCardBorderBottom);
export default __webpack_public_path__ + "static/media/character-card-border-bottom.1fd1f5ced88b2b20c3560b910204acb6.svg";
export { ForwardRef as ReactComponent };